<template>
	<div class="main" v-title data-title="零部件网站公告">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<div class="barprebox bgwhite">
				<div class="mt25 ml20 txl">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">网站公告</h1>
					</div>
				</div>
				<div class="formWBase txl">
					<div class="list-item mt20">
						<h1 class="color1 font18 txc">{{noticeinfo.title}}</h1>
						<p class="txc pd20 font12">发布日期:{{noticeinfo.create_time}}</p>
						<div class="noticeD">
							{{noticeinfo.content}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				noticeinfo: [],
				goods_id:''
			};
		},
		created() {
			this.goods_id = this.$route.query.goodsid;
			this.handnoticeinfo();
		},
		methods: {
			handnoticeinfo() {
				this.$postcn('tongji/announcementDetails', {
					id: this.goods_id,
				}, this).then((res) => {
					if (res.data.code == 200) {
						this.noticeinfo = res.data.data
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			},
		}
	}
</script>

<style scoped>
	.list-item .noticeD {
		position: relative;
		padding: 10px 20px;
		line-height: 20px;
		color: #999;
		font-size: 12px;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-divider {
		margin: 12px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/notice/noticeinfo.vue